module.exports = __webpack_public_path__ + "static/Video_Thumbnail@2x-14502fd8c998cc4d6219e2a3a1f726c9.png";